import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import BackNext from '../../Common/SubComponents/BackNext';
import { Form, Row, Col, Container } from 'react-bootstrap';
import { StyledRadioInput } from '../../../Helpers/Inputs/index';
import AffordableIcon from '../../../../icons/affordable.svg?react';
import { SvgIcon } from '@mui/material';
import { string, object, array as yuparray } from 'yup';
import IneligibleForm from '../Helpers/Input/IneligibleForm';
import { setNestedValue } from '../Helpers/Constant';
import { customValidators } from '../../../Helpers/Validators/customValidators'
import {
  ARIZONA,
  MARYLAND,
  ILLINOIS,
  VERMONT,
  WISCONSIN,
  COLORADO,
  KENTUCKY,
  CONNECTICUT,
  INDIANA,
  SOUTH_DAKOTA,
  MICHIGAN,
  OHIO,
  OREGON,
  MAINE,
  FLORIDA,
  NORTH_DAKOTA,
  NEW_YORK,
  CALIFORNIA,
  TENNESSEE,
  MINNESOTA,
} from '../../../Helpers/Constants/States';

export default function MedicalEligibility(props) {
  const state = props.state;
  const formMethods = useForm({
    resolver: yupResolver(MedicalEligibility.ValidationSchema),
    mode: 'all',
    reValidateMode: 'all',
    defaultValues: props.formState
  });

  const { handleSubmit, trigger, register, setValue } = formMethods;

  const ineligibleDefault = [
    {
      type: '',
      name: [],
      numberOfChildren: '',
      nameofChildren: [],
    },
  ];
  useEffect(() => {
    props.onFieldChange("isVisible", true);
  }, [])

  useEffect(() => {
    register('state');
    setValue('state', state);
  }, [register]);

  const SeclectBoxOption = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
  ];

  const handleValueChangeWithIneligible = (field, value) => {
    if (value === 'yes') {
      const newForm = ineligibleDefault;
      newForm[0].type = field;
      const ineligibleForm = [...props.formState.ineligible, newForm[0]];
      props.onStepFieldChange(field, value, 'ineligible', ineligibleForm);
      setValue('ineligible', ineligibleForm);
    } else {
      const ineligibleForm = props.formState.ineligible.filter((form, formIndex) => form.type !== field);
      props.onStepFieldChange(
        field,
        value,
        'ineligible',
        ineligibleForm
      );
      setValue("ineligible", ineligibleForm);
      trigger("ineligible");
    }
  };
  const getUnbornLabel = () => {
    if (state === FLORIDA) {
      return 'Is anyone to be covered the mother or father of a child currently conceived but as yet unborn or within the last 12 months, has anyone to be covered been diagnosed with or treated by a licensed member of the medical profession for infertility?';
    } else if (state === NEW_YORK) {
      return 'To the best of your knowledge and belief, is anyone to be covered the mother or father of a child currently conceived but as yet unborn or within the last 12 months, has anyone to be covered been diagnosed with or treated by a member of the medical profession for infertility?';
    } else if (state === NORTH_DAKOTA) {
      return 'Is anyone to be covered the mother or father of a child currently conceived but as yet unborn or within the last 12 months, has anyone to be covered been medically diagnosed with or treated by a member of the medical profession for infertility?';
    } else if (state === MARYLAND || state === TENNESSEE) {
      return 'Is anyone to be covered the mother or father of a child currently conceived but as yet unborn?';
    } else {
      return 'Is anyone to be covered the mother or father of a child currently conceived but as yet unborn or within the last 12 months, has anyone to be covered been diagnosed with or treated by a member of the medical profession for infertility?';
    }
  };
  const getHospitalizationLabel = () => {
    if (state === CALIFORNIA) {
      return 'Is anyone to be covered currently confined in a Hospital (other than for the sole act of donating an organ) or nursing home, or within the last 12 months, has a member of the medical profession recommended hospitalization or nursing home confinement?';
    } else if (state === FLORIDA) {
      return 'Is anyone to be covered currently confined in a Hospital or nursing home, or has a licensed member of the medical profession recommended hospitalization or nursing home confinement?';
    } else if (state === MARYLAND) {
      return 'Is anyone to be covered currently confined in a Hospital or nursing home, or, within the last seven years, has a member of the medical profession recommended hospitalization or nursing home confinement?';
    } else if (state === MAINE) {
      return 'For conditions other than HIV, is anyone to be covered currently confined in a Hospital or nursing home, or has a member of the medical profession recommended hospitalization or nursing home confinement?';
    } else if (state === MINNESOTA) {
      return 'Is anyone to be covered currently confined in a Hospital or nursing home, or has a member of the medical profession recommended hospitalization or nursing home confinement within the past 12 months?';
    } else if (state === OREGON) {
      return 'Is anyone to be covered currently confined in a Hospital (other than the sole act of donating an organ) or nursing home, or has a member of the medical profession recommended hospitalization or nursing home confinement?';
    } else {
      return 'Is anyone to be covered currently confined in a Hospital or nursing home, or has a member of the medical profession recommended hospitalization or nursing home confinement?';
    }
  };
  const getPlannedProcedureLabel = () => {
    if (state === CALIFORNIA) {
      return 'Within the last 12 months, has anyone to be covered been diagnosed with a condition by a member of the medical profession for which treatment includes a medical procedure (including but not limited to surgery, organ or bone marrow transplant, or join replacement. Diagnosed does not include the act of donating an organ)?';
    } else if (state === FLORIDA) {
      return 'Does anyone to be covered have a condition for which a medical procedure (including but not limited to surgery, organ or bone marrow transplant, or joint replacement) has been planned or the possibility of which has been discussed with a licensed member of the medical profession within the past 12 months?';
    } else if (state === MARYLAND) {
      return 'Does anyone to be covered have a condition for which a medical procedure (including but not limited to surgery, organ or bone marrow transplant, or joint replacement) has been planned or the possibility of which has been discussed with a member of the medical profession within the past 12 months?';
    } else if (state === MAINE) {
      return 'Does anyone to be covered have a condition, other than HIV, for which a medical procedure (including but not limited to surgery, organ or bone marrow transplant, or joint replacement) has been planned or the possibility of which has been discussed with a member of the medical profession within the past 12 months?';
    } else if (state === NEW_YORK) {
      return 'To the best of your knowledge and belief, does anyone to be covered have a condition for which a medical procedure (including but not limited to surgery, organ or bone marrow transplant, or joint replacement) has been planned or the possibility of which has been discussed with a member of the medical profession within the past 12 months?';
    } else if (state === OREGON) {
      return 'Does anyone to be covered have a condition for which a medical procedure (including but not limited to surgery, organ or bone marrow transplant, or joint replacement. Diagnosed does not include the act of donating an organ.) has been planned or the possibility of which has been discussed with a member of the medical profession within the past 12 months?';
    } else {
      return 'Does anyone to be covered have a condition for which a medical procedure (including but not limited to surgery, organ or bone marrow transplant, or joint replacement) has been planned or the possibility of which has been discussed with a member of the medical profession within the past 12 months?';
    }
  };
  const getDiagnosticTestsLabel = () => {
    if (state === ARIZONA) {
      return 'For conditions other than AIDS or HIV, within the last six months, has anyone to be covered been advised by a member of the medical profession to have tests or treatment that has not yet been done or is anyone undergoing evaluation following an abnormal test result?';
    } else if (state === CALIFORNIA) {
      return 'Within the last six months, has anyone to be covered had any medical tests concluded for which results are pending or is anyone undergoing medical evaluation due to test results received?';
    } else if (state === FLORIDA) {
      return 'Within the last six months, has anyone to be covered been advised by a licensed member of the medical profession to have tests or treatment that has not yet been done or is anyone undergoing evaluation following an abnormal test result?';
    } else if (state === ILLINOIS) {
      return 'Within the last six months, has anyone to be covered been advised by a member of the medical profession to have tests or treatment that has not yet been done or the results of which caused a member of the medical profession to advise further diagnostic techniques or procedures?';
    } else if (state === KENTUCKY) {
      return 'Within the last six months, has anyone to be covered been advised by a member of the medical profession to have tests or treatment that has not yet been done or the results of which caused a member of the medical profession to advise further diagnostic techniques or procedures?';
    } else if (state === MARYLAND) {
      return 'Within the last six months, has anyone to be covered been advised by a member of the medical profession to have tests or treatment that has not yet been done or, within the last six months has anyone undergone evaluation following an abnormal test result?';
    } else if (state === MAINE) {
      return 'For conditions other than HIV, within the last six months, has anyone to be covered been advised by a member of the medical profession to have tests or treatment that has not yet been done or is anyone undergoing evaluation following an abnormal test result?';
    } else if (state === NEW_YORK) {
      return 'Does anyone to be covered have a condition for which a medical procedure (including but not limited to surgery, organ or bone marrow transplant, or joint replacement. Diagnosed does not include the act of donating an organ.) has been planned or the possibility of which has been discussed with a member of the medical profession within the past 12 months?';
    } else if (state === OHIO) {
      return 'Within the last six months, has anyone to be covered been advised by a member of the medical profession to have tests, excluding tests for human immunodeficiency virus (HIV), or treatment that has not yet been done or is anyone undergoing evaluation following an abnormal test result?';
    } else if (state === VERMONT) {
      return 'Within the last six months, has anyone to be covered been advised by a member of the medical profession to have tests, excluding tests for human immunodeficiency virus (HIV), or treatment that has not yet been done or is anyone undergoing evaluation following an abnormal test result?';
    } else {
      return 'Within the last six months, has anyone to be covered been advised by a member of the medical profession to have tests or treatment that has not yet been done or is anyone undergoing evaluation following an abnormal test result?';
    }
  };
  const getDiabetesLabel = () => {
    if (state === FLORIDA) {
      return 'Has anyone to be covered been diagnosed by a licensed member of the medical profession with diabetes before the age of 30 (except for gestational diabetes)?';
    } else if (state === MARYLAND) {
      return 'Does anyone to be covered have diabetes that was diagnosed or treated by a member of the medical profession, prior to the age of 30 (except for gestational diabetes)?';
    } else if (state === NEW_YORK) {
      return 'To the best of your knowledge and belief, has anyone to be covered been diagnosed by a member of the medical profession with diabetes before the age of 30 (except for gestational diabetes)?';
    } else if (state === NORTH_DAKOTA) {
      return 'Has anyone to be covered been medically diagnosed by a member of the medical profession with diabetes before the age of 30 (except for gestational diabetes)?';
    } else {
      return 'Has anyone to be covered been diagnosed by a member of the medical profession with diabetes before the age of 30 (except for gestational diabetes)?';
    }
  };
  const getAidsLabel = () => {
    if (state === ARIZONA || state === COLORADO || state === SOUTH_DAKOTA) {
      return 'Within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS) by a member of the medical profession?';
    } else if (state === CALIFORNIA) {
      return 'Within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS) or AIDS-related conditions (ARC) by a member of the medical profession?';
    } else if (state === CONNECTICUT) {
      return 'Within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS), AIDS-related complex or AIDS-related conditions by a member of the medical profession?';
    } else if (state === ILLINOIS) {
      return 'Within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS) by a physician or an appropriately licensed clinical professional acting within the scope of his/her license, or has anyone to be covered tested positive for human immunodeficiency virus (HIV)?';
    } else if (state === INDIANA) {
      return 'Within the last five years, has anyone to be covered been diagnosed with or treated by a member of the medical profession as having human immunodeficiency virus (HIV)?';
    } else if (state === MARYLAND) {
      return 'Within the last five years, has anyone to be covered been diagnosed with or treated for known symptoms or known indications of acquired immune deficiency syndrome (AIDS) by a member of the medical profession, or tested positive for human immunodeficiency virus (HIV)?';
    } else if (state === MAINE) {
      return 'Within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS) by a member of the medical profession, or has anyone to be covered tested positive for human immunodeficiency virus (HIV)?';
    } else if (state === MICHIGAN) {
      return 'Within the last five years, has anyone to be covered ever been medically treated or medically diagnosed by a member of the medical profession as having acquired immune deficiency syndrome (AIDS), AIDS-related complex (ARC), or has anyone to be covered had a positive result under an HIV test that is considered reliable by the federal Centers for Disease Control and Prevention approved by the Michigan Department of Community Health?"';
    } else if (state === NEW_YORK) {
      return 'To the best of your knowledge and belief, within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS) by a member of the medical profession, or has anyone to be covered tested positive for human immunodeficiency virus (HIV)?';
    } else if (state === NORTH_DAKOTA) {
      return 'Within the last five years, has anyone to be covered been medically diagnosed with or treated by a member of the medical profession as having acquired immune deficiency syndrome (AIDS) or human immunodeficiency virus (HIV)?';
    } else if (state === VERMONT) {
      return 'Within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS) by a licensed physician?';
    } else if (state === WISCONSIN) {
      return 'Within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS)?';
    } else {
      return 'Within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS) by a member of the medical profession, or has anyone to be covered tested positive for human immunodeficiency virus (HIV)?';
    }
  };
  const getInfertilityLabel = () => {
    if (state === TENNESSEE)
      return "In the last 12 months, has anyone to be covered been diagnosed with or treated by a member of the medical profession for infertility?"
    else
      return "Within the last 12 months, has anyone to be covered been diagnosed with or treated by a member of the medical profession for infertility?"
  }
  const getIneligibleComponent = (field, list) => {
    let item;
    list.map((ineligible, index) => {
      if (ineligible.type === field) {
        item = ineligible;
        item.index = index;
      }
    });
    const handleValueChangeloop = (field, type, value, longFieldName) => {
      setValue(longFieldName, value);
      props.onFieldChange(
        'ineligible',
        props.formState.ineligible.map((form, formIndex) => {
          if (type === form.type) {
            if (field === "name")
              form[field] = value;
            else
              setNestedValue(form, field, value);
            return form;
          } else {
            return form;
          }
        })
      );
    };
    const handleChildrenNames = (field, type, value, longFieldName) => {
      const resetIneligible = props.formState.ineligible.map((form, formIndex) => {
        if (type === form.type) {
          if (field === 'numberOfChildren') {
            setNestedValue(form, field, value);

            const previousChildLength = form.nameofChildren.length;
            const totalChild = parseInt(value);
            if (totalChild > previousChildLength) {
              const addChildInput = totalChild - previousChildLength;
              for (let i = 1; i <= addChildInput; i++) {
                if (type === form.type) {
                  form.nameofChildren.push({ name: '' });
                }
              }
            } else {
              const removeChildInput = previousChildLength - totalChild;
              form.nameofChildren.splice(`-${removeChildInput}`);
            }
            return form;
          }
        } else {
          if (type === form.type) {
            setNestedValue(form, field, value);
            return form;
          } else {
            return form;
          }
        }
      })
      props.onFieldChange('ineligible', resetIneligible);
      setValue('ineligible', resetIneligible);
    };
    if (item) {
      return (
        <div>
          <IneligibleForm
            formState={item}
            onChange={(field, value, type, longFieldName) => {
              handleValueChangeloop(field, type, value, longFieldName);
            }}
            ChildChange={(field, value, type, longFieldName) => {
              handleChildrenNames(field, type, value, longFieldName);
            }}
            state={state}
            noOfChilds={props.noOfChilds ? props.noOfChilds : ''}
            allProps={props}
            trigger={trigger}
            key={item.index}
            index={item.index}
            customOption={props.getListOfPlanIncludedPerson()}
          />
        </div>
      );
    }
  };
  const onSubmit = () => {
    props.onNext();
  }

  return (
    <Container fluid className='border-class medical-eligibility-form'>
      <FormProvider {...formMethods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="justify-content-center family-history mt-4">
            <Col className='col-div'>
              <Row className="justify-content-center pt-4 mb-2">
                <SvgIcon component={AffordableIcon} className="small-icons" color="primary" fontSize="large" />
              </Row>
              <Row className="justify-content-center pt-2 pb-3">
                <h4>Medical Underwriting</h4>
              </Row>
              <h6>{getUnbornLabel()}</h6>
              <div className='mb-3'>
                <StyledRadioInput
                  name="unborn"
                  id="unborn"
                  // label={getUnbornLable()}
                  value={props.formState.unborn}
                  options={SeclectBoxOption}
                  onChange={(e) => handleValueChangeWithIneligible('unborn', e)}
                  isWhiteBackground={true}
                  isBlankIcon={true}
                />
              </div>
              {props.formState.unborn === 'yes' && getIneligibleComponent('unborn', props.formState.ineligible)}

              {(state === MARYLAND || state === TENNESSEE) &&
                <div>
                  <h6>{getInfertilityLabel()}</h6>
                  <div className='mb-3'>
                    <StyledRadioInput
                      name="infertility"
                      id="infertility"
                      value={props.formState.infertility}
                      options={SeclectBoxOption}
                      onChange={(e) => handleValueChangeWithIneligible('infertility', e)}
                      isWhiteBackground={true}
                      isBlankIcon={true}
                    />
                  </div>
                </div>
              }
              {props.formState.infertility === 'yes' && getIneligibleComponent('infertility', props.formState.ineligible)}

              <h6>{getHospitalizationLabel()}</h6>
              <div className='mb-3'>
                <StyledRadioInput
                  name="hospitalization"
                  id="hospitalization"
                  value={props.formState.hospitalization}
                  options={SeclectBoxOption}
                  onChange={(e) => handleValueChangeWithIneligible('hospitalization', e)}
                  isWhiteBackground={true}
                  isBlankIcon={true}
                />
              </div>

              {props.formState.hospitalization === 'yes' && getIneligibleComponent('hospitalization', props.formState.ineligible)}

              <h6>{getPlannedProcedureLabel()}</h6>
              <div className='mb-3'>
                <StyledRadioInput
                  name="plannedProcedure"
                  id="plannedProcedure"
                  value={props.formState.plannedProcedure}
                  options={SeclectBoxOption}
                  onChange={(e) => handleValueChangeWithIneligible('plannedProcedure', e)}
                  isWhiteBackground={true}
                  isBlankIcon={true}
                />
              </div>

              {props.formState.plannedProcedure === 'yes' && getIneligibleComponent('plannedProcedure', props.formState.ineligible)}

              <h6>{getDiagnosticTestsLabel()}</h6>
              <div className='mb-3'>
                <StyledRadioInput
                  name="diagnosticTests"
                  id="diagnosticTests"
                  value={props.formState.diagnosticTests}
                  options={SeclectBoxOption}
                  onChange={(e) => handleValueChangeWithIneligible('diagnosticTests', e)}
                  isWhiteBackground={true}
                  isBlankIcon={true}
                />
              </div>
              {props.formState.diagnosticTests === 'yes' && getIneligibleComponent('diagnosticTests', props.formState.ineligible)}

              <h6>{getDiabetesLabel()}</h6>
              <div className='mb-3'>
                <StyledRadioInput
                  name="diabetes"
                  id="diabetes"
                  value={props.formState.diabetes}
                  options={SeclectBoxOption}
                  onChange={(e) => handleValueChangeWithIneligible('diabetes', e)}
                  isWhiteBackground={true}
                  isBlankIcon={true}
                />
              </div>
              {props.formState.diabetes === 'yes' && getIneligibleComponent('diabetes', props.formState.ineligible)}

              {(state !== MARYLAND && state !== MAINE && state !== OREGON) &&
                <React.Fragment>
                  <h6>{getAidsLabel()}</h6>
                  <div className='mb-3'>
                    <StyledRadioInput
                      name="aids"
                      id="aids"
                      value={props.formState.aids}
                      options={SeclectBoxOption}
                      onChange={(e) => handleValueChangeWithIneligible('aids', e)}
                      isWhiteBackground={true}
                      isBlankIcon={true}
                    />
                  </div>
                  {props.formState.aids === 'yes' && getIneligibleComponent('aids', props.formState.ineligible)}
                </React.Fragment>
              }
            </Col>
          </Row>

          <div className='backnext-wrapper'>
            <BackNext onBack={props.onBack} isAflac={true} continueLabel={{ text: "Next" }} />
          </div>

        </Form>
      </FormProvider>
    </Container>
  );
}

MedicalEligibility.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func,
  onFieldChange: PropTypes.func.isRequired,
  onBack: PropTypes.func,
};
MedicalEligibility.ValidationSchema = object().shape({
  unborn: string().required('This field is required.'),
  infertility: string().when('state', {
    is: (state) => state === MARYLAND || state === TENNESSEE,
    then: (schema) => schema.required('This field is required!.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  hospitalization: string().required('This field is required.'),
  plannedProcedure: string().required('This field is required.'),
  diagnosticTests: string().required('This field is required.'),
  diabetes: string().required('This field is required.'),
  aids: string().when('state', {
    is: (state) => (state !== MARYLAND && state !== MAINE && state !== OREGON),
    then: (schema) => schema.required('This field is required.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  ineligible: yuparray(
    object().shape({
      name: yuparray().of(string().required('Name is required.'))
        .min(1, 'Name is required.'),
      numberOfChildren: string().when('name', {
        is: (name) => name && name.includes('Dependent Child'),
        then: (schema) => schema.required('This field is required.'),
        otherwise: (schema) => schema.notRequired(),
      }),
      nameofChildren: yuparray().when('name', {
        is: (name) => name && name.includes('Dependent Child'),
        then: (schema) => yuparray(
          object().shape({
            name: customValidators.string().isValidNameWithFiftyChar('Child Name is required.', true),
          })
        ),
      }),
    })
  ),
});

MedicalEligibility.DefaultFormState = (prefill = false) => {
  return {
    unborn: prefill ? 'false' : '',
    infertility: prefill ? 'false' : '',
    hospitalization: prefill ? 'false' : '',
    plannedProcedure: prefill ? 'false' : '',
    diagnosticTests: prefill ? 'false' : '',
    diabetes: prefill ? 'false' : '',
    aids: prefill ? 'false' : '',
    ineligible: [],
    isVisible: false
  };
};
